import { Button } from '@components/shared/Button/Button';
import Modal from '@components/shared/Modal/Modal';
import { useTexts } from 'utils/useTexts';

type AdditionalIncomeConfirmationModalProps = {
  isModalOpen: boolean;
  closeModal: () => void;
  handleYesIDo: () => void;
  handleNoImDone: () => void;
};

const AddMoreAdditionalIncomeModal = ({
  isModalOpen,
  closeModal,
  handleYesIDo,
  handleNoImDone,
}: AdditionalIncomeConfirmationModalProps) => {
  const { t } = useTexts();
  return (
    <Modal
      title={t('employmentAndIncome.addAdditionalIncome.title')}
      isOpen={isModalOpen}
      onClose={closeModal}
    >
      <ul className="iLendingCDX-modal-content__list">
        <li>
          <p>{t('employmentAndIncome.addMoreAdditionalIncome.2yearsHistory')}</p>
        </li>
        <li>
          <p>{t('employmentAndIncome.addMoreAdditionalIncome.addOtherIncome')}</p>
        </li>
        <li>
          <p>{t('employmentAndIncome.addMoreAdditionalIncome.approvalChances')}</p>
        </li>
      </ul>

      <div className="iLendingCDX-modal-buttons">
        <Button
          variant="ghost"
          size="lg"
          onClick={handleYesIDo}
        >
          {t('employmentAndIncome.addMoreAdditionalIncome.yesIDo')}
        </Button>
        <Button
          variant="ghost"
          size="lg"
          onClick={handleNoImDone}
        >
          {t('employmentAndIncome.addAdditionalIncome.noImDone')}
        </Button>
      </div>
    </Modal>
  );
};

export default AddMoreAdditionalIncomeModal;
